export const PAGE_SEO_ATTR = 'data-ab-page-seo';
export const PAGE_SEO_PUBLIC_ORIGIN = 'https://www.anglerbuilt.com';

export const HOME_PATH = '/';
export const HOME_DOCUMENT_TITLE =
  'Angler Built | Find the Best Price on Fishing Gear';
export const HOME_META_DESCRIPTION =
  'Find the best price on fishing gear with Angler Built. Compare current offers, discover verified savings, and explore gear guides and setup tools for ice and open water.';

export function resolvePagePublicOrigin(origin) {
  const raw = origin || PAGE_SEO_PUBLIC_ORIGIN;
  return String(raw).replace(/\/$/, '');
}

export function buildPageCanonicalUrl(path, origin) {
  const cleanOrigin = resolvePagePublicOrigin(origin);
  const rawPath = path == null ? '' : String(path);
  if (rawPath === '' || rawPath === '/') return `${cleanOrigin}/`;
  const normalized = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
  return `${cleanOrigin}${normalized.replace(/\/+$/, '')}`;
}
